import { useDocumentTitle as useBaseDocumentTitle } from '@/hooks';
import { IHasUserData, IUserTransaction } from '@/interfaces';
import { IUserData } from '@/lib/interface';
import useUrlParams from './useUrlParams';

type TParams = IHasUserData & {
	transactions?: IUserTransaction[];
	subAccounts?: IUserData[];
};

const useDocumentTitle = ({ userData, transactions, subAccounts }: TParams) => {

	const { tab } = useUrlParams();

	const title = (
		userData
			? (
				tab === 'photos'
					? `${userData.username} • (${userData?.pictures?.length ?? 0}) Photo(s)`
					: tab === 'transactions'
						? `${userData?.username} • (${transactions?.length ?? 0}) Transaction(s)`
						: tab === 'subAccounts'
							? `${userData.username} • (${subAccounts?.length ?? 0}) Sous compte(s)`
							: undefined
			)
			: undefined
	);

	useBaseDocumentTitle({ title });

};

export default useDocumentTitle;
